<nav class="navbar"  >
    <div class="navbar-content">
		<a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
			<i class="feather icon-menu"></i>
		</a>
		<div class="background-container w-auto">
			<!--<img src="assets/images/backgrounds/background_header_2.png" class="background-header" alt="monex">-->
            <div  class="background-header" >
                <div class="user-info-container">
                    <div class="d-flex wrapper">
                        <div class="d-flex align-items-center ">
                            <p-avatar *ngIf="!this.userInfo['userImage']" [label]="calculateInitials()" styleClass="mr-2"
                                      [style]="{ 'background-color': '#001865', color: '#ffffff' }"
                                      [className]="'avatar-with-background cursor-pointer'" shape="circle"
                                      (click)="editProfileImage()" size="large">

                            </p-avatar>
                            <p-avatar *ngIf="this.userInfo['userImage']" [image]="this.userInfo['userImage']"
                                      [className]="'avatar-with-background cursor-pointer'" styleClass="mr-2 " size="large"
                                      shape="circle" (click)="editProfileImage()">
                            </p-avatar>
                        </div>
                        <div class="user-info">
                            <div class="user-name headline1 ">
                                <p class="full-name">{{capitalizeWord(fullName) }}</p>
                                <p class="secret-word fst-italic" *ngIf="secretWord && secretWord !== ''">({{secretWord}})
                                </p>
                            </div>
                            <div class="last-session">
                                <span>{{'Ultimo acceso'|translate}}</span> {{lastLogOn.date}} {{lastLogOn.hour}} (GMT-6)
                            </div>
                        </div>
                    </div>
                    <div class="icon-container" *ngIf="!showOnlyTranslateIcon">
                        <app-notification [currentLang]="currentLang" (setNotificationRead)="setReadNotification($event)"
                                          (deleteNotification)="deleteNotification($event)"
                                          (updateAllNotifications)="updateAllNotifications($event)" (openModalPendingPaymentsToAuthEvent)="openModal($event)" [isOpenNotificationDialog]="showNotiDialog" ></app-notification>

                        <div>
                            <app-system-configuration>

                            </app-system-configuration>

                        </div>
                        <div ngbDropdown class="d-inline-block" #drop_help="ngbDropdown">
                            <a id="helpDropdown" role="button" (click)="$event.stopPropagation(); drop_help.open();">
                                <img src="assets/images/icons/Help.svg" alt="discover_your_bank_icon" class="menu_icon-help">
                            </a>
                            <div ngbDropdownMenu aria-labelledby="helpDropdown" class=" dropdown-menu-end menu-list">
                                <a (click)="redirectDiscoverUBank()" target="_blank"
                                   ngbDropdownItem class="py-2 list">
                                    {{ 'Descubre tu Banca' | translate }}
                                </a>
                            </div>
                        </div>
                        <div ngbDropdown class="d-inline-block" #drop_translate="ngbDropdown">
                            <a id="languageDropdown" role="button"
                               (click)="$event.stopPropagation(); drop_translate.open();">
                                <img src="assets/images/icons/translate_icon.svg" alt="translate_icon" class="menu_icon">
                            </a>
                            <div ngbDropdownMenu aria-labelledby="languageDropdown" class="dropdown-menu-end">
                                <a *ngFor="let language of translate.getLangs()" (click)="switchLang(language)"
                                   ngbDropdownItem class="py-2">
                                    <img src="assets/images/flags/{{language}}.svg" class="wd-20 me-1" pTooltip="{{language}}"
                                         alt="{{language}}">
                                    <span class="ms-1"> {{language | translate}} </span>
                                </a>
                            </div>
                        </div>

                        <a id="logout" role="button" (click)="onLogout($event)">
                            <img src="assets/images/icons/logout_icon.svg" alt="logout_icon" class="menu_icon">
                        </a>
                    </div>
                    <div class="icon-container icon-container-one" *ngIf="showOnlyTranslateIcon">
                        <div ngbDropdown class="d-inline-block" #drop_translate="ngbDropdown">
                            <a id="languageDropdownDiscover" role="button"
                               (click)="$event.stopPropagation(); drop_translate.open();">
                                <img src="assets/images/icons/translate_icon.svg" alt="translate_icon" class="menu_icon">
                            </a>
                            <div ngbDropdownMenu aria-labelledby="languageDropdownDiscover" class="dropdown-menu-end">
                                <a *ngFor="let language of translate.getLangs()" (click)="switchLang(language)"
                                   ngbDropdownItem class="py-2">
                                    <img src="assets/images/flags/{{language}}.svg" class="wd-20 me-1" pTooltip="{{language}}"
                                         alt="{{language}}">
                                    <span class="ms-1"> {{language | translate}} </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

		</div>
	</div>
</nav>

<div class="progressSpinner" *ngIf="loadingDeleteNotification || loadingReadNotification">
	<p-progressSpinner></p-progressSpinner>
</div>

<div class="flex justify-content-center" *ngIf="showPendingPaymentAuthorizationModal">
    <p-dialog [(visible)]="showPendingPaymentAuthorizationModal" [modal]="true" [style]="{ top: '70px', 'max-width': '605px'}" [draggable]="false"
              [resizable]="false" [closable]="false" position="top" [showHeader]="false" appendTo="body" class="pending-payments-auth-modal-container">
        <app-pending-payments-authorizations-modal (closeModalEvent)="onClosePendingPaymentsAuthorizationModalEvent()" (setNotificationRead)="setReadNotification($event)"  [showModal]="showPendingPaymentAuthorizationModal" [modalData]="modalData" (notifyCloseNotificationDialog)="hideNotificationDialog()"></app-pending-payments-authorizations-modal>
    </p-dialog>
</div>